import { CommonModule } from '@angular/common';
import { Component, computed, inject, Input, OnInit, ViewChild } from '@angular/core';
import { ciInterface2 } from 'src/app/util/interfaces/ci';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { CmdbSearchGadgetComponent } from 'src/app/page_component/cmdb-search-gadget/cmdb-search-gadget.component';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faSquare, faCheckSquare, faTrash } from '@fortawesome/free-solid-svg-icons';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { ModalComponent } from 'src/app/page_component_item/modal/modal.component';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { CmdbRegisterPageBondService } from './data/cmdb-register-page-bond.service';
import { DotBounceLoadingEffectModule } from 'src/app/page_component_item/dot-bounce-loading-effect/dot-bounce-loading-effect.module';
import { MspButtonComponent } from 'src/app/page_component_item/msp-button/msp-button.component';

@Component({
	selector: 'cpi-cmdb-register-page-bond',
	standalone: true,
	imports: [
		CommonModule,
		CmdbSearchGadgetComponent,
		FaIconComponent,
		AppRoutingModule,
		ModalComponent,
		DotBounceLoadingEffectModule,
		MspButtonComponent,
	],
	templateUrl: './cmdb-register-page-bond.component.html',
	styleUrl: './cmdb-register-page-bond.component.scss',
})
export class CmdbRegisterPageBondComponent implements OnInit {
	private readonly labelsService = inject(LabelsService);
	private readonly notificationService = inject(NotificationService);
	private readonly cmdbRegisterPageBondService = inject(CmdbRegisterPageBondService);

	@ViewChild('bondCiModal') bondCiModal: ModalComponent;

	@Input() selectedCi: ciInterface2;
	@Input() viewType: 'read' | 'edit';

	icons = {
		faCheckSquare: faCheckSquare,
		faSquare: faSquare,
		faTrash: faTrash,
	};

	labels: LabelsInterface;

	ignoreBondCiArr: string[] = [];
	selectedBondCi: ciInterface2;
	unbondListCi: string[] = [];

	isAddingBond = false;
	isDeletingBond = false;

	constructor() {
		this.labels = computed(() => this.labelsService.labels())();
	}

	ngOnInit(): void {
		this.ignoreBondCiArr.push(this.selectedCi.id);
		for (const ci of this.selectedCi.relationships.childs) {
			this.ignoreBondCiArr.push(ci.id_related);
		}
		for (const ci of this.selectedCi.relationships.parents) {
			this.ignoreBondCiArr.push(ci.id_related);
		}
	}

	selectBondCi(ci: ciInterface2): void {
		if (ci.id.toString() == this.selectedCi.id.toString()) {
			this.notificationService.setNotificationMessage('_Você não pode vincular um ativo à ele mesmo');
			return;
		}

		const searchSelectedOnlyIds = [];
		for (const bondedParent of this.selectedCi.relationships.parents) {
			searchSelectedOnlyIds.push(bondedParent.id_related.toString());
		}
		for (const bondedChild of this.selectedCi.relationships.childs) {
			searchSelectedOnlyIds.push(bondedChild.id_related.toString());
		}
		if (searchSelectedOnlyIds.includes(ci.id.toString())) {
			this.notificationService.setNotificationMessage('_Este item já foi adicionado à lista');
			return;
		}

		this.selectedBondCi = ci;
	}

	bondCi(type_bond: 'Child' | 'Parent'): void {
		if (this.isAddingBond || this.selectedBondCi == undefined) return;

		this.isAddingBond = true;
		this.cmdbRegisterPageBondService.bondCi(this.selectedCi, this.selectedBondCi, type_bond).subscribe((bondRes) => {
			for (const [index, newBond] of bondRes.ids.entries()) {
				const temporary: ciInterface2['relationships']['childs'][number] = {
					id_relation: newBond,
					type: '',
					type_relation: type_bond,
					id_related: this.selectedBondCi.id,
					name: this.selectedBondCi.identification,
				};
				if (type_bond === 'Child') this.selectedCi.relationships.childs.push({ ...temporary });
				else if (type_bond === 'Parent') this.selectedCi.relationships.parents.push({ ...temporary });
			}

			this.ignoreBondCiArr.push(this.selectedBondCi.id);

			this.notificationService.setNotificationMessage(this.labels.lbl_adicionado_com_sucesso);
			this.isAddingBond = false;
			this.bondCiModal.closeModal();
		});
	}

	unbondCi(ci: ciInterface2['relationships']['childs'][number]): void {
		if (this.isDeletingBond) return;
		this.isDeletingBond = true;
		this.cmdbRegisterPageBondService.unbondCi(this.selectedCi.id, ci.id_relation).subscribe(() => {
			this.ignoreBondCiArr.splice(this.ignoreBondCiArr.indexOf(ci.id_related.toString()));
			this.notificationService.setNotificationMessage(this.labels.lbl_removido_com_sucesso);

			for (const [index, relation] of this.selectedCi.relationships.parents.entries()) {
				if (relation.id_relation === ci.id_relation) {
					this.selectedCi.relationships.parents.splice(index, 1);
					continue;
				}
			}

			for (const [index, relation] of this.selectedCi.relationships.childs.entries()) {
				if (relation.id_relation === ci.id_relation) {
					this.selectedCi.relationships.childs.splice(index, 1);
					continue;
				}
			}

			this.isDeletingBond = false;
		});
	}

	selectMultipleCI(ciBond, index): void {
		if (ciBond.isChecked == true) {
			ciBond.isChecked = false;
			const idIndex = this.unbondListCi.indexOf(ciBond.id_relation);
			this.unbondListCi.splice(idIndex, 1);
		} else {
			ciBond.isChecked = true;
			this.unbondListCi.push(ciBond.relationId);
		}
	}

	unbondSelectedCi(event: Event): void {
		if (this.unbondListCi.length === 0) {
			this.notificationService.setNotificationMessage(this.labels.lbl_selecione_bond_remover);
			return;
		}

		if ((<HTMLElement>event.target).classList.contains('double-click')) {
			this.cmdbRegisterPageBondService.unbondCiMultiples(this.selectedCi.id, this.unbondListCi).subscribe(() => {
				for (let index = this.selectedCi.relationships.parents.length - 1; index >= 0; index--) {
					const parent = this.selectedCi.relationships.parents[index];
					if (this.unbondListCi.includes(parent.id_relation)) {
						this.selectedCi.relationships.parents.splice(index, 1);
					}
				}

				for (let index = this.selectedCi.relationships.childs.length - 1; index >= 0; index--) {
					const child = this.selectedCi.relationships.childs[index];
					if (this.unbondListCi.includes(child.id_relation)) {
						this.selectedCi.relationships.childs.splice(index, 1);
					}
				}

				this.notificationService.setNotificationMessage(this.labels.lbl_removido_com_sucesso);
				this.isDeletingBond = false;
				this.unbondListCi = [];
			});
		} else {
			(<HTMLElement>event.target).classList.add('double-click');
			setTimeout(() => {
				(<HTMLElement>event.target).classList.remove('double-click');
			}, 5000);
		}
	}

	unbondAllCi(event: Event): void {
		if (this.selectedCi.relationships.parents.length === 0 && this.selectedCi.relationships.childs.length === 0) {
			this.notificationService.setNotificationMessage(this.labels.lbl_nenhum_ci_para_remover);
			return;
		}

		if ((<HTMLElement>event.target).classList.contains('double-click')) {
			let allBondList = [];

			for (const parent of this.selectedCi.relationships.parents) {
				allBondList.push(parent.id_relation);
			}

			for (const child of this.selectedCi.relationships.childs) {
				allBondList.push(child.id_relation);
			}

			this.cmdbRegisterPageBondService.unbondCiMultiples(this.selectedCi.id, allBondList).subscribe(() => {
				this.selectedCi.relationships.parents.length = 0;
				this.selectedCi.relationships.childs.length = 0;
				this.notificationService.setNotificationMessage(this.labels.lbl_removido_com_sucesso);
			});

			this.isDeletingBond = false;
			allBondList = [];
		} else {
			(<HTMLElement>event.target).classList.add('double-click');

			setTimeout(() => {
				(<HTMLElement>event.target).classList.remove('double-click');
			}, 5000);
		}
	}

	confirmButton(elementReference: HTMLElement): void {
		this.notificationService.setNotificationMessage(this.labels.lbl_clique_confirmar_acao);
		elementReference.classList.add('confirmClick');
		setTimeout(() => {
			elementReference.classList.remove('confirmClick');
		}, 5000);
	}
}
